import { useState } from "react";

function useFormState () {
  const [loading, setLoading] = useState(false);
  const [showErrorFields, setShowErrorFields] = useState(false);

  return {
    loading,
    setLoading,
    showErrorFields, 
    setShowErrorFields
  };
}

export default useFormState;
